import {ExamRequestResultTypeEnum} from 'domain/usecases/private/exam-results/get-exam-requests';
import {ExamResultsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';

const {filter} = translations['pt-br'].privateFlow.examResults;

const EXAMS_FILTERS = [
	{
		label: filter.all,
		category: ExamRequestResultTypeEnum.ALL,
		dataTagId: ExamResultsTaggingEnum.CLICK_FILTRAR_TODOS_TIPOS_EXAMES,
	},
	{
		label: filter.laboratory,
		category: ExamRequestResultTypeEnum.LABORATORY,
		dataTagId: ExamResultsTaggingEnum.CLICK_FILTRAR_EXAME_LABORATORIAL,
	},
	{
		label: filter.image,
		category: ExamRequestResultTypeEnum.IMAGE,
		dataTagId: ExamResultsTaggingEnum.CLICK_FILTRAR_EXAME_DE_IMAGEM,
	},
	{
		label: filter.varied,
		category: ExamRequestResultTypeEnum.VARIED,
		dataTagId: ExamResultsTaggingEnum.CLICK_FILTRAR_EXAME_LABORATORIAL_E_IMAGEM,
	},
];

export {EXAMS_FILTERS};
